export default {"src":"/_next/static/media/happy-peace-sign.174f86d7.svg","height":193,"width":140,"blurWidth":0,"blurHeight":0};